// extracted by mini-css-extract-plugin
export default {"imageContainer":"Wishlist_imageContainer__XGBG2","grid":"Wishlist_grid__fX5nO"};